"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicLegacyMinimumPassword = exports.BasicPassword = exports.BasicPhone = exports.BasicSlug = exports.BasicLastname = exports.BasicFirstname = exports.BasicEmail = exports.BasicCountry = exports.BasicEULA = exports.BasicOTP = exports.BasicAudience = exports.VALIDATION_REGEX = void 0;
const zod_1 = require("zod");
const shared_1 = require("../shared");
exports.VALIDATION_REGEX = {
  email: '[A-Za-z0-9._%+-@]',
  password: '[A-Za-z0-9!@#$%^&*()_\\-+=\\[\\]{}|:;"\'<>,.?/~`]',
  first_name: '[A-Za-zÀ-ÖØ-öø-ÿĀ-žА-Яа-яЁё一-龯\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF\s\'-]',
  last_name: '[A-Za-zÀ-ÖØ-öø-ÿĀ-žА-Яа-яЁё一-龯\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF\s\'-]',
  slug: '[a-zA-Z0-9._-]'
};
const VALIDATION = {
  email: new RegExp(`^${exports.VALIDATION_REGEX.email}+$`),
  password: new RegExp(`^${exports.VALIDATION_REGEX.password}+$`),
  first_name: new RegExp(`^${exports.VALIDATION_REGEX.first_name}+$`),
  last_name: new RegExp(`^${exports.VALIDATION_REGEX.last_name}+$`),
  slug: new RegExp(`^${exports.VALIDATION_REGEX.slug}+$`)
};
exports.BasicAudience = zod_1.z.nativeEnum(shared_1.EnumAudience).default(shared_1.EnumAudience.web).optional();
exports.BasicOTP = zod_1.z.number({
  errorMap: () => ({
    message: 'otp_invalid'
  })
});
exports.BasicEULA = zod_1.z.literal(true, {
  errorMap: () => ({
    message: `accept_sla_invalid`
  })
});
exports.BasicCountry = zod_1.z.string().trim().min(1, "country_invalid");
exports.BasicEmail = zod_1.z.string({
  errorMap: () => ({
    message: 'email_invalid'
  })
}).email().toLowerCase().trim();
exports.BasicFirstname = zod_1.z.string().trim().min(1, "first_name_invalid").refine(v => {
  var _a;
  return (_a = VALIDATION.first_name) === null || _a === void 0 ? void 0 : _a.test(v !== null && v !== void 0 ? v : "");
}, `first_name_invalid`);
exports.BasicLastname = zod_1.z.string().trim().min(1, "last_name_invalid").refine(v => {
  var _a;
  return (_a = VALIDATION.last_name) === null || _a === void 0 ? void 0 : _a.test(v !== null && v !== void 0 ? v : "");
}, `last_name_invalid`);
exports.BasicSlug = zod_1.z.string().min(3, "slug_invalid").toLowerCase().trim().refine(v => {
  var _a;
  return (_a = VALIDATION.slug) === null || _a === void 0 ? void 0 : _a.test(v !== null && v !== void 0 ? v : "");
}, `slug_invalid`);
exports.BasicPhone = zod_1.z.string({
  errorMap: () => ({
    message: 'mobile_phone_invalid'
  })
}).trim().min(9, `mobile_phone_invalid`).refine(v => /^\+[0-9]+$/.test(v !== null && v !== void 0 ? v : ""), `mobile_phone_invalid`);
exports.BasicPassword = zod_1.z.string().trim().min(8, `password_invalid`).refine(v => {
  var _a;
  return ((_a = VALIDATION.password) === null || _a === void 0 ? void 0 : _a.test(v !== null && v !== void 0 ? v : "")) && v.length > 7;
}, {
  message: 'password_required'
});
exports.BasicLegacyMinimumPassword = zod_1.z.string().trim().min(3, `password_invalid`).refine(v => {
  var _a;
  return ((_a = VALIDATION.password) === null || _a === void 0 ? void 0 : _a.test(v !== null && v !== void 0 ? v : "")) && v.length > 2;
}, {
  message: 'password_required'
});
